<template>
  <div class="mod-product">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.productName" :placeholder="$t('product.productName')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="dataForm.productCode" :placeholder="$t('product.productCode')" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.category" :placeholder="$t('product.category')" clearable>
          <el-option :label="$t('product.massage')" value="按摩用品"></el-option>
          <el-option :label="$t('product.beauty')" value="美容用品"></el-option>
          <el-option :label="$t('product.footbath')" value="足浴用品"></el-option>
          <el-option :label="$t('product.fitness')" value="健身用品"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="dataForm.status" :placeholder="$t('common.status')" clearable>
          <el-option :label="$t('common.enabled')" :value="1"></el-option>
          <el-option :label="$t('common.disabled')" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">{{ $t('common.query') }}</el-button>
        <el-button type="primary" @click="addOrUpdateHandle()">{{ $t('common.add') }}</el-button>
        <el-button type="danger" @click="deleteHandle()" :disabled="dataListSelections.length <= 0">{{ $t('common.batchDelete') }}</el-button>
        <el-button type="success" @click="exportData()">{{ $t('common.export') }}</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="id"
        header-align="center"
        align="center"
        label="ID">
      </el-table-column>
      <el-table-column
        prop="productCode"
        header-align="center"
        align="center"
        :label="$t('product.productCode')">
      </el-table-column>
      <el-table-column
        prop="productName"
        header-align="center"
        align="center"
        :label="$t('product.productName')">
      </el-table-column>
      <el-table-column
        prop="category"
        header-align="center"
        align="center"
        :label="$t('product.category')">
      </el-table-column>
      <el-table-column
        prop="brand"
        header-align="center"
        align="center"
        :label="$t('product.brand')">
      </el-table-column>
      <el-table-column
        prop="specification"
        header-align="center"
        align="center"
        :label="$t('product.specification')">
      </el-table-column>
      <el-table-column
        prop="unit"
        header-align="center"
        align="center"
        :label="$t('product.unit')">
      </el-table-column>
      <el-table-column
        prop="purchasePrice"
        header-align="center"
        align="center"
        :label="$t('product.purchasePrice')">
        <template slot-scope="scope">
          ¥{{ scope.row.purchasePrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="salePrice"
        header-align="center"
        align="center"
        :label="$t('product.salePrice')">
        <template slot-scope="scope">
          ¥{{ scope.row.salePrice }}
        </template>
      </el-table-column>
      <el-table-column
        prop="currentStock"
        header-align="center"
        align="center"
        :label="$t('product.currentStock')">
        <template slot-scope="scope">
          <span :class="getStockClass(scope.row.currentStock, scope.row.minStock)">
            {{ scope.row.currentStock || 0 }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="minStock"
        header-align="center"
        align="center"
        :label="$t('product.minStock')">
      </el-table-column>
      <el-table-column
        prop="status"
        header-align="center"
        align="center"
        :label="$t('product.status')">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'">
            {{ scope.row.status === 1 ? $t('product.enabled') : $t('product.disabled') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        header-align="center"
        align="center"
        :label="$t('common.createTime')">
        <template slot-scope="scope">
          {{ scope.row.createTime | dateFormat }}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        :label="$t('common.operation')">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('common.edit') }}</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('common.delete') }}</el-button>
          <el-button type="text" size="small" @click="stockManageHandle(scope.row)">{{ $t('product.stockManagement') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    <!-- 库存管理弹窗 -->
    <stock-manage v-if="stockManageVisible" ref="stockManage" @refreshDataList="getDataList"></stock-manage>
  </div>
</template>

<script>
  import AddOrUpdate from './add-or-update'
  import StockManage from './stock-manage'
  export default {
    data () {
      return {
        dataForm: {
          productName: '',
          productCode: '',
          category: '',
          status: ''
        },
        dataList: [],
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false,
        stockManageVisible: false
      }
    },
    components: {
      AddOrUpdate,
      StockManage
    },
    created () {
      this.getDataList()
    },
    activated () {
      this.getDataList()
    },
    methods: {
      // 获取数据列表
      getDataList () {
        console.log('Token from storage:', this.$storage.get('Token'))
        this.dataListLoading = true
        const params = {
          'page': this.pageIndex,
          'limit': this.pageSize
        }
        // 只添加非空的搜索参数
        if (this.dataForm.productName) params.productName = this.dataForm.productName
        if (this.dataForm.productCode) params.productCode = this.dataForm.productCode
        if (this.dataForm.category) params.category = this.dataForm.category
        if (this.dataForm.status !== null && this.dataForm.status !== '') params.status = this.dataForm.status
        
        console.log('Request params:', params)
        
        this.$http({
          url: 'product/page',
          method: 'get',
          params: params
        }).then(({data}) => {
          console.log('Product list response:', data)
          console.log('data.data:', data.data)
          console.log('data.data.list:', data.data ? data.data.list : 'data.data is undefined')
          if (data && data.code === 0 && data.data) {
            this.dataList = data.data.list || []
            this.totalPage = data.data.total || 0
            console.log('Loaded products:', this.dataList.length)
            console.log('Total pages:', this.totalPage)
          } else {
            console.log('No data or error:', data)
            this.dataList = []
            this.totalPage = 0
          }
          this.dataListLoading = false
        }).catch(error => {
          console.error('Product list error:', error)
          this.dataList = []
          this.totalPage = 0
          this.dataListLoading = false
        })
      },
      // 每页数
      sizeChangeHandle (val) {
        this.pageSize = val
        this.pageIndex = 1
        this.getDataList()
      },
      // 当前页
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()
      },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      // 新增 / 修改
      addOrUpdateHandle (id) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          this.$refs.addOrUpdate.init(id)
        })
      },
      // 删除
      deleteHandle (id) {
        var ids = id ? [id] : this.dataListSelections.map(item => {
          return item.id
        })
        this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: 'product/delete',
            method: 'post',
            data: ids
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      },
      // 库存管理
      stockManageHandle (row) {
        this.stockManageVisible = true
        this.$nextTick(() => {
          this.$refs.stockManage.init(row)
        })
      },
      // 导出数据
      exportData () {
        this.$http({
          url: 'product/export',
          method: 'get',
          params: {
            'productName': this.dataForm.productName,
            'productCode': this.dataForm.productCode,
            'category': this.dataForm.category,
            'status': this.dataForm.status
          },
          responseType: 'blob'
        }).then(({data}) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = '产品列表.xlsx'
          link.click()
          window.URL.revokeObjectURL(url)
        })
      },
      // 获取库存样式类
      getStockClass (currentStock, minStock) {
        if (currentStock <= minStock) {
          return 'text-danger'
        } else if (currentStock <= minStock * 1.5) {
          return 'text-warning'
        }
        return 'text-success'
      }
    }
  }
</script>

<style scoped>
  .text-danger {
    color: #f56c6c;
    font-weight: bold;
  }
  .text-warning {
    color: #e6a23c;
    font-weight: bold;
  }
  .text-success {
    color: #67c23a;
  }
</style>
